<template>
   <div style="width:100%; height:100vh;">
		<div v-if="eventType === 'buttons'" class="counter">
			<div class="content">
				<div class="">
				<h1>OUIGO ON TOUR</h1>
				<h2> <b>Omar Montes y Ana Mena en concierto</b> </h2>
				<h2>¿Te vienes a ALMAD Festival?</h2>
			</div>
			<div class="buttons">
				<div @click="goWidget('madrid')">OUIGO ON TOUR <br> desde Madrid</div>
				<div @click="goWidget('albacete')">OUIGO ON TOUR <br> desde Albacete</div>
				<div @click="goWidget('alicante')">OUIGO ON TOUR <br> Alicante</div>
			</div>
			</div>
			<!-- <img src="https://cdn-nuxt.wegow.com/static/img/68c8405.svg" alt="Conciertos Wegow" class="logo-wegow"> -->
			
		</div>
		<!-- <div v-if="openSale" style="width:100%; height:10vh;">La venta se habrirá dentro de poco</div> -->
		<iframe v-if="eventType === 'alicante'" src="https://www.wegow.com/es-es/widget/ouigo-on-tour" class="openIframe" frameborder="0" ></iframe>
		<iframe v-if="eventType === 'madrid'" src="https://www.wegow.com/es-es/widget/ouigo-on-tour-madrid" class="openIframe" frameborder="0" ></iframe>
		<iframe v-if="eventType === 'albacete'" src="https://www.wegow.com/es-es/widget/ouigo-on-tour-albacete" class="openIframe" frameborder="0" ></iframe>
	</div>
</template>

<script>
import Vue from 'vue'
import VueGtag from 'vue-gtag'

Vue.use(VueGtag, {
  config: {
    id: 'UA-61060589-4',
    anonymizeIp: true,
    ecommerce: {
      enabled: true
    },
  },
  enabled: false,
})

export default {
	data() {
		return {
			// finishTime: new Date('2022', '03', '02', '12', '00', '0', '0').getTime(),
			finishTime: 1648893600000,
			openSale: false,
			diference: 0,
			maxMinutesDelay: 2,
			minSecondsDelay: 0,
			interval: null,
			eventType: 'buttons'
		}
	},
	created() {
		let actualTime = new Date().getTime();
		this.openSale = ((this.finishTime - actualTime)/1000).toFixed(0) < this.diference;
		if (!this.openSale) {
			this.diference = Math.floor(Math.random() * ((this.maxMinutesDelay * 60)- this.minSecondsDelay) + this.minSecondsDelay);
			this.interval = setInterval(async () => {
				let actualTime = new Date().getTime();
				if (((this.finishTime - actualTime)/1000).toFixed(0) < this.diference) {
					if ( this.$gtag && typeof this.$gtag.event === 'function' ) {
						this.$gtag.event('auto-reload', {
							'event_category': 'landing-ouigo-on-tour'
						});
					}
					window.location.reload();
				}
			},250);
		}
		
	}, 
	mounted() {
    setTimeout(() => {
      if ( this.$gtag && typeof this.$gtag.event === 'function' ) {
        this.$gtag.event('landing-ouigo-on-tour', {
          'event_category': 'landing-ouigo-on-tour'
        })
      }
    }, 2500);
	},
	methods:{
		goWidget(type) {
			// this.eventType = type;
      if ( this.$gtag && typeof this.$gtag.event === 'function' ) {
        this.$gtag.event('landing-ouigo-on-tour-' + type, {
          'event_category': 'landing-ouigo-on-tour'
        })
      }
			if (type === "alicante") {
				location.href='https://www.wegow.com/es-es/festivales/ouigo-on-tour';
			} else if (type === "madrid") {
				location.href='https://www.wegow.com/es-es/festivales/ouigo-on-tour-madrid';
			} else if (type === "albacete") {
				location.href='https://www.wegow.com/es-es/festivales/ouigo-on-tour-albacete';
			}
		}
	}
}
</script>

<style lang="scss">
body {
	// overflow-y: hidden;
	background-color: #000214 !important;
	height: 100vh;
}
.openIframe {
	width: 100%;
  height: 100vh;
}

.logo-wegow {
	width: 64px;
	margin-right: 64px;
}
.buttons {
	display: flex;
	justify-content: center;
	margin-top: 128px;
	margin-bottom: 128px;
	div {
		display: flex;
    flex-direction: column;
    align-items: center;
		text-align: center;

		padding: 6px 14px 6px 14px;
		width: 170px;
		margin-right: 24px;
		margin-left: 24px;

		background: #404256;
		border-radius: 100px;
		font-weight: 600;
		border: 1px solid transparent;
		cursor: pointer;
		span {
			font-weight: 300;
			color: #7F8295;
		}
		&:hover{
			border: 1px solid #14caba;
		}
	}
}
h1, div {
	color: white
}
h1 {
	font-size: 3em;
	text-align: center;
	font-weight: 300;
	margin-bottom: 16px;
	margin-top: 32px;
}
h2 {
	text-align: center;

	font-weight: 300;
	font-size: 2em;
	b {
		font-weight: 600;
		font-size: 1.5em;
		margin-bottom: 24px;
	}
} 
.counter {
	display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
	max-width: 100%;
	margin-left: auto;
	margin-right: auto;
	justify-content: space-between;

	background-image: url("https://cdn.wegow.com/media/events/ouigo-on-tour-ana-mena-y-omar-montes-en-concierto/ouigo-on-tour-ana-mena-y-omar-montes-en-concierto-1681828020.6970174.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
	.content {
		overflow-y: overlay;
    min-height: 100vh;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: space-between;

		margin-left: auto;
		margin-right: auto;
	}
}
::-webkit-scrollbar {
    display: none;
}
			
@media (max-width: 900px) {
	.buttons {
		flex-direction: column;
		margin-top: 1px;
		margin-bottom: 64px;
		div {
			margin-right: 0px;
			margin-left: 0px;
			margin-top: 18px;
			font-size: 0.75em;
		}
	}

	h1 {
		font-size: 2em;
		margin-bottom: 48px;
	}
	h2 {
		font-size: 1em;
		b {
			font-size: 1.5em;
			margin-bottom: 24px;
		}
	} 
}

</style>
